<script setup>
import { onBeforeUnmount, ref, watch } from 'vue'
const props = defineProps({ message:String, type:{type:String,default:'success'} })
const emit = defineEmits(['clear'])
const visible = ref(false)
let timer = null
function scheduleClear(){
  visible.value = true
  if(timer) clearTimeout(timer)
  timer = setTimeout(()=>{ visible.value=false; emit('clear') },3000)
}
watch(()=>props.message,(message)=>{ if(message) scheduleClear() })
onBeforeUnmount(()=>{if(timer)clearTimeout(timer)})
</script>
<template><div v-if="visible && message" class="toast" :class="type" role="status" aria-live="polite">{{message}}</div></template>
